// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"9":"8669b7b5","100":"9f64c9b2","582":"94569648","860":"395926b7"}[chunkId] + ".chunk.css";
};